
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"19","height":"16","viewBox":"0 0 19 16","fill":"currentColor","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('ellipse',{attrs:{"cx":"3.16669","cy":"6.0202","rx":"2.16669","ry":"2.16082","stroke":"black","stroke-width":"1.2","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('ellipse',{attrs:{"cx":"9.67646","cy":"10.6374","rx":"2.16669","ry":"2.16082","stroke":"black","stroke-width":"1.2","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('ellipse',{attrs:{"cx":"16.1511","cy":"6.61395","rx":"2.16669","ry":"2.16082","stroke":"black","stroke-width":"1.2","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M3.1661 8.17969V14.8565","stroke":"black","stroke-width":"1.2","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M3.1661 1V3.30945","stroke":"black","stroke-width":"1.2","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M9.67587 12.7959V14.8538","stroke":"black","stroke-width":"1.2","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M9.67587 1V8.47713","stroke":"black","stroke-width":"1.2","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M16.1505 9.22711V14.8605","stroke":"black","stroke-width":"1.2","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M16.1505 1V4.45274","stroke":"black","stroke-width":"1.2","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    